/**
 * Что выделить после удаления блока: блок слева от удалённого; удалили первый —
 * `null` (выбор блока снимается, остаётся выделенный урок и его панель).
 */
export const blockLeftOf = (blocks: readonly { id: number }[], id: number): number | null => {
  const i = blocks.findIndex((b) => b.id === id)
  return i > 0 ? blocks[i - 1].id : null
}
